import angular from 'angular';
import DynamicFiltersDirective from './dynamic-filters.directive';

let DynamicFiltersModule = angular.module('catalog.productsList.dynamicFilter', [])
  .directive('dynamicFilters', DynamicFiltersDirective);

export default DynamicFiltersModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/products-list/dynamic-filters/dynamic-filters.js
 **/